import Vue from 'vue'
import App from '@/views/shell/app'

import router from '@/router'
// import $ from "jquery";
import '@/assets/css/global.css'
import 'font-awesome/scss/font-awesome.scss'

import 'normalize.css' //css差异性兼容

import animate from 'animate.css'

import Utils from '@/utils/util'
Vue.use(Utils);

import store from '../store'

import VueWorker from 'vue-worker'
Vue.use(VueWorker)

//elementUI
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/elementUI.css'
import {
  Table, TableColumn, Button, ButtonGroup, Badge, Tooltip, Switch, Form, FormItem, Input, InputNumber, Notification, Dialog, Tabs, TabPane, Popover, Dropdown, DropdownMenu, DropdownItem, Checkbox, CheckboxButton, CheckboxGroup, Loading,
  DatePicker, Pagination, Select, Option,Tag} from "element-ui";
Vue.use(Table);
Vue.use(InputNumber);
Vue.use(TableColumn);
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Badge);
Vue.use(Tooltip);
Vue.use(Switch);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Dialog);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Popover);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(DatePicker);
Vue.use(Pagination);
Vue.use(Select);
Vue.use(Option);
Vue.use(Tag);
Vue.prototype.$notify = Notification;

Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
//eruda
// javascript:(function () { var script = document.createElement('script'); script.src="//cdn.jsdelivr.net/npm/eruda"; document.body.appendChild(script); script.onload = function () { eruda.init() } })();

new Vue({
  el: '#app',
  router,
  store,
  Utils,
  created: function () {
    this.postParams.numberId = this.GetUrlParams("numberId");

  },
  methods: {
    GetUrlParams: function (val) {
      var url = window.parent.location.href;
      if (url.indexOf("?") === -1) return null;
      var after = window.parent.location.search.substr(1) || window.parent.location.hash.split("?")[1];
      if (after) {
        try {
          var reg = new RegExp("(^|&)" + val + "=([^&]*)(&|$)");
          return decodeURIComponent(after.match(reg)[2]);
        } catch (error) {
          return null;
        }
      }
    }
  },
  data: {
    postParams: { numberId: "" }
  },
  render: createElement => {
    store.dispatch(store.state.mutatinTypes.INIT_SCREEN_RESIZE);
    return createElement(App);
  }
})
